<div class="bg-[#ff4d4d] text-white p-6 text-center w-full flex flex-col gap-6">
  <h2 class="text-lg font-bold" i18n="@@DeckProgressLossDialog_Title">
    Switching tabs will lead to a progress loss in the current deck!
  </h2>

  <p class="text-base flex items-center justify-center" i18n="@@DeckProgressLossDialog_Content">
    Are you sure you want to proceed?
  </p>

  <div class="flex justify-center gap-4">
    <button
      mat-button
      class="text-sm px-5 py-2.5 rounded-lg bg-white border border-[#ff4d4d] text-[#ff4d4d] font-bold transition-all duration-200 hover:bg-[#ffeaea]"
      (click)="onCancel()"
      i18n="@@DeckProgressLossDialog_Cancel"
    >
      Cancel
    </button>

    <button
      mat-raised-button
      color="primary"
      class="text-sm px-5 py-2.5 rounded-lg bg-white border border-[#ff4d4d] text-[#ff4d4d] font-bold transition-all duration-200 hover:bg-[#ffeaea]"
      (click)="onProceed()"
      i18n="@@DeckProgressLossDialog__ProceedButton"
    >
      Proceed
    </button>
  </div>
</div>
